"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Routing = require("Functions/Routing");
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _Editor = _interopRequireDefault(require("Components/TextEditor/Editor"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Message = _interopRequireDefault(require("../../../Chat/Message"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _fileInputUtilities = require("Components/Forms/Functions/fileInputUtilities");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
const ChatV2 = props => {
  const [message, setMessage] = (0, _react.useState)("");
  const [statusMessages, setStatusMessages] = (0, _react.useState)({});
  const [status, setStatus] = (0, _react.useState)({});
  const [loading, setLoading] = (0, _react.useState)(false);
  const [previousMessages, setPreviousMessages] = (0, _react.useState)();
  const [files, setFiles] = (0, _react.useState)([]);
  const userRole = window.app.state.session.user.roles[0];
  const relatedPratician = props.relatedPratician;
  const relatedProject = props.projectId;
  const projectNumber = props.recordNumber;
  let sendMessageTo = props.relatedPratician;
  let readDeltex = undefined;
  let readPratician = undefined;
  let userLogin = window.app.state.session.user.login;
  (0, _react.useEffect)(() => {
    if (!projectNumber || !relatedPratician) {
      return;
    }
    fetchMessages();
  }, [projectNumber, relatedPratician]);
  (0, _react.useEffect)(() => {
    previousMessages && props.handleFilesList(previousMessages);
  }, [previousMessages]);
  (0, _react.useEffect)(() => {
    app.push({
      event: 'requestChatRefresh',
      cb: fetchMessages
    });
    return () => {
      app.delete({
        event: 'requestChatRefresh',
        cb: fetchMessages
      });
    };
  }, []);
  const loader = loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  const fetchMessages = params => {
    setLoading(true);
    if (userRole === "pratician") {
      (0, _ajaxRequest.default)((0, _Routing.action)('updateMessageStatus'), {
        data: {
          related_project: projectNumber,
          read_by_pratician: true
        }
      });
    }
    if (userRole === "deltex") {
      (0, _ajaxRequest.default)((0, _Routing.action)('updateMessageStatus'), {
        data: {
          related_project: projectNumber,
          read_by_deltex: true
        }
      });
    }
    (0, _ajaxRequest.default)((0, _Routing.action)('getAllMessages'), {
      data: {
        related_project: projectNumber,
        with_count: false
      }
    }).then(response => {
      var _response$data, _response$data$;
      setLoading(false);
      setPreviousMessages((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$ = _response$data[0]) === null || _response$data$ === void 0 ? void 0 : _response$data$.content);
    });
  };
  const sendMessage = async () => {
    if (loading === true) return;
    try {
      setLoading(true);
      if ((previousMessages === null || previousMessages === void 0 ? void 0 : previousMessages.length) > 0) {
        let response = await (0, _ajaxRequest.default)((0, _Routing.action)('updateChat'), {
          data: {
            message: message,
            send_to: sendMessageTo,
            sent_by: userLogin,
            related_project: projectNumber,
            files: files,
            read_by_pratician: readPratician,
            read_by_deltex: readDeltex
          },
          timeout: 30 * 1000
        });
        fetchMessages();
        setMessage('__editor-txt:');
        setStatus(response);
        setFiles([]);
      } else {
        let response = await (0, _ajaxRequest.default)((0, _Routing.action)('createChat'), {
          data: {
            message: message,
            sent_by: userLogin,
            send_to: sendMessageTo,
            related_project: projectNumber,
            related_pratician: relatedPratician,
            related_project_id: relatedProject,
            files: files,
            read_by_pratician: readPratician,
            read_by_deltex: readDeltex
          },
          timeout: 30 * 1000
        });
        setPreviousMessages(response.data.content);
        setMessage('__editor-txt:');
        fetchMessages();
        setStatus(response);
        setFiles([]);
      }
    } catch (response) {
      setStatus(response);
      setLoading(false);
      setStatusMessages(response.status_messages);
      return;
    }
  };
  const handleMessageStatus = () => {
    if (userRole === "pratician") {
      sendMessageTo = "deltex";
      readPratician = true;
      readDeltex = false;
      sendMessage();
    } else if (userRole === "deltex") {
      userLogin = "deltex";
      sendMessageTo = relatedPratician;
      readPratician = false;
      readDeltex = true;
      sendMessage();
    }
  };
  const handleFileChange = _ref => {
    let {
      e,
      previews,
      name
    } = _ref;
    setStatusMessages((0, _fileInputUtilities.getStatusMessage)({
      status: statusMessages,
      previews,
      name
    }));
    setStatus({});
    setFiles(previews);
  };
  if (userRole === "ortho") {
    return null;
  }
  const previous_messages = (previousMessages || []).map(message => /*#__PURE__*/_react.default.createElement(_Message.default, {
    key: message.message_date,
    message: message
  }));
  const output = /*#__PURE__*/_react.default.createElement("div", {
    className: "project_chat__messages"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Messages"), /*#__PURE__*/_react.default.createElement("div", {
    className: "chat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "previous_messages"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Historique des messages\xA0:"), previous_messages), props.projectStatus !== 'over' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Editor.default, {
    className: "u-padding-top-20",
    "text-only": true,
    label: "Message",
    value: message,
    onChange: e => setMessage(e.value),
    name: "chat[message]",
    status: statusMessages
  }), /*#__PURE__*/_react.default.createElement(_FileInput.default, {
    onChange: handleFileChange,
    value: files,
    name: "chat[files]",
    model: "chat",
    field: "files",
    label: "Fichier(s)",
    multiple: true,
    status: {},
    accept: "dicom, image, pdf, zip"
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['primary']) + ' u-margin-top-15',
    onClick: handleMessageStatus
  }, "Envoyer", loader), (0, _getFormStatus.default)(status)) : undefined));
  return output;
};
var _default = exports.default = ChatV2;
